let __nullType;
const NullType = __nullType = Object.seal({
    fullName: 'Array',
    name: 'Array',
    namespace: '',
    baseType: __nullType,
    isArray: false,
    factory: () => null,
});
export default NullType;
